export const T = {
  en_GB: {
    summaryHeading: "Summary",
    transcriptHeading: "Extracted text",
  },
  nb_NO: {
    summaryHeading: "Sammendrag",
    transcriptHeading: "Utdratt tekst",
  },
} as const;
